import format from 'date-fns/format'
import zonedTimeToUtc from 'date-fns-tz/zonedTimeToUtc'
import setSeconds from 'date-fns/setSeconds'
import parseISO from 'date-fns/parseISO'

const dateTimeFormater = (date: Date, time: Date, timezone = 'Europe/London'): string => {

  const dateWithTimezone = zonedTimeToUtc(parseISO(format(date, 'yyyy-MM-dd') + ' ' + format(time, 'HH:mm:ss')), timezone)
  return setSeconds(dateWithTimezone, 0).toISOString().replace('.000', '')

}

export default dateTimeFormater
